import React, { useRef, useState } from 'react';
import { Search, Pencil } from 'lucide-react';
import { useT } from '../lib/LanguageContext';

export default function BottomBar({ onSearch, onCompose, searching }) {
  const t = useT();
  const [q, setQ] = useState('');
  const fabRef = useRef(null);

  const onChange = (e) => {
    const v = e.target.value;
    setQ(v);
    onSearch(v);
  };

  const handleCompose = () => {
    onCompose(fabRef.current?.getBoundingClientRect() || null);
  };

  return (
    <div
      className="md:hidden fixed bottom-0 inset-x-0 z-30 px-8 pt-2 flex flex-col items-center gap-2"
      style={{ paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 28px)' }}
      data-testid="bottom-bar"
    >
      <div className="w-full flex items-center justify-center gap-3">
        <div className="relative flex-1 max-w-[300px]">
          {searching && (
            <div className="absolute inset-0 rounded-full search-glow-ring pointer-events-none" aria-hidden />
          )}
          <div className="relative m-[2px] flex items-center gap-3 h-12 px-4 rounded-full bg-keep-surface border border-keep-border text-keep-text shadow-keepHover">
            <Search className="w-5 h-5 text-keep-textMuted flex-shrink-0" />
            <input
              value={q}
              onChange={onChange}
              placeholder={t('bottomBar.searchPlaceholder')}
              className="flex-1 min-w-0 bg-transparent outline-none text-[15px] text-keep-text placeholder:text-keep-textMuted"
              data-testid="bottombar-search-input"
            />
          </div>
        </div>
        <button
          ref={fabRef}
          type="button"
          onClick={handleCompose}
          className="w-12 h-12 rounded-full bg-keep-accent text-keep-onAccent flex items-center justify-center shadow-keepHover flex-shrink-0"
          aria-label={t('bottomBar.newNote')}
          data-testid="bottombar-compose"
        >
          <Pencil className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
}
